import { Filters } from '../../utils/enums';

export const supportedFilters = [
  Filters.Spend,
  Filters.Installs,
  Filters.Impressions,
  Filters.Campaigns,
  Filters.Countries,
  Filters.ExcludedTag,
];
